import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoginForm } from '../../components/forms/LoginForm';
import { doLogin } from '../../redux/reducers/auth';
import styles from './Login.scss';
import { showAndHide } from '../../redux/reducers/message';

class Login extends Component {
  constructor(props) {
    super(props);
    this.hasError = false;
  }

  handleSubmit = (values) => {
    this.hasError = false;
    this.props.doLogin('auth/login/', values);
    return false;
  };

  componentDidMount = () => {
    if (
      this.props.auth.loaded &&
      this.props.auth.token &&
      this.props.auth.user.profile.isAdmin
    ) {
      this.props.history.push('/submissions/new');
    }
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.auth.loaded && this.props.auth.token) {
      this.props.history.push('/submissions/new');
    }
    if (this.props.auth.hasError && !this.hasError) {
      this.hasError = true;
      this.handleError(this.props.auth.error);
    }
  };

  handleError = (error) => {
    let errorMessage = null;
    if (error.message) {
      errorMessage = error.message;
    }
    if (error.status === 400) {
      errorMessage = error.json.nonFieldErrors[0];
    }
    if (error.status === 500) {
      errorMessage = error.statusText;
    }
    this.props.showAndHide({ type: 'error', text: errorMessage });
  };

  render() {
    return (
      <Container className={styles.container}>
        <Row className='login'>
          <div className='std-form-container mx-auto my-auto'>
            <div>
              {this.props.location.state && this.props.location.state.from && (
                <div>You must be logged in to access that page</div>
              )}
              <div id='login' className='zombieDiv'>
                <img src='./images/giphy_1.gif' height='80px' alt='zombie' />
                <h3>Login</h3>
              </div>
            </div>
            <LoginForm handleSubmit={this.handleSubmit} />
          </div>
        </Row>
      </Container>
    );
  }
}

Login.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
};

const mapStateToProps = ({ auth }) => ({
  auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ doLogin, showAndHide }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Login);
